import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Courses.css';
import TopperCard from './TopperCard';
import { getAllToppers } from '../firebase/firestoreService';

const CoursesCBSE = () => {
  const [toppers, setToppers] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllToppers()
      .then(data => setToppers(data.filter(t => t.course === 'CBSE')))
      .catch(() => {});
  }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Course",
        "name": "CBSE Coaching Class 5 to 10 — Ulhasnagar & Kalyan",
        "description": "Best CBSE coaching for Class 5 to 10 in Ulhasnagar and Kalyan. Expert faculty covering all NCERT subjects with regular tests and mock exams.",
        "provider": { "@type": "EducationalOrganization", "name": "Nalanda Group Tuitions", "url": "https://nalandagrouptuitions.com" }
      }) }} />

      <div className="ngt-page-banner">
        <h1>CBSE Coaching in Ulhasnagar &amp; Kalyan — Class 5 to 10</h1>
        <p>Best CBSE Classes · Nalanda Group Tuitions · NCERT-Aligned Curriculum</p>
      </div>

      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item">Courses</li>
          <li className="breadcrumb-item active">CBSE Coaching Ulhasnagar</li>
        </ol>
      </nav>

      <section className="ngt-course-detail-page">
        <div className="container">
          <div className="row g-5 align-items-start">
            <div className="col-lg-8">
              <div className="ngt-card">
                <h2 style={{ fontFamily: 'Playfair Display,serif', color: 'var(--ngt-navy)', marginBottom: '1rem' }}>
                  CBSE Coaching — Class 5 to 10 (Ulhasnagar &amp; Kalyan)
                </h2>
                <p style={{ color: 'var(--ngt-grey)' }}>
                  NGT's <strong>CBSE coaching programme</strong> delivers complete NCERT-aligned instruction for
                  Class 5 to 10, with a focus on Science and Mathematics. Our experienced CBSE faculty
                  ensure every student understands concepts deeply, performs consistently in school exams,
                  and is fully prepared for Class 10 CBSE board examinations.
                </p>
                <hr className="ngt-divider" />
                <h3 style={{ color: 'var(--ngt-navy)', fontSize: '1.1rem', marginBottom: '0.8rem' }}>What Is Covered</h3>
                <ul style={{ color: 'var(--ngt-grey)', paddingLeft: '1.4rem', lineHeight: '2' }}>
                  <li>Complete CBSE NCERT syllabus — Class 5 to 10</li>
                  <li>Mathematics, Science, English, Social Science</li>
                  <li>CBSE sample papers, unit tests, and pre-board mock exams</li>
                  <li>Chapter-wise notes, question banks, and previous year papers</li>
                  <li>Doubt sessions and personalised attention for every student</li>
                  <li>Regular parent-teacher meetings and academic progress reports</li>
                </ul>
                <hr className="ngt-divider" />
                <h3 style={{ color: 'var(--ngt-navy)', fontSize: '1.1rem', marginBottom: '0.8rem' }}>Class Schedule</h3>
                <p style={{ color: 'var(--ngt-grey)' }}>
                  Monday through Saturday. Morning and evening batches. Contact us to confirm current batch availability.
                </p>
                <hr className="ngt-divider" />
                <div className="ngt-course-seo-block">
                  <h3>Best CBSE Classes for Class 5 to 10 in Ulhasnagar</h3>
                  <p>
                    Nalanda Group Tuitions is the preferred choice for <strong>CBSE coaching in Ulhasnagar and Kalyan</strong>.
                    Our faculty brings years of experience teaching CBSE curriculum, helping students master
                    difficult concepts in Maths and Science while building consistent habits that lead to
                    top scores in CBSE board exams. NGT's two Ulhasnagar branches are easily accessible
                    from Kalyan, Ambernath, and Badlapur.
                  </p>
                  <div className="ngt-course-links" style={{ marginTop: '1rem' }}>
                    <span style={{ fontSize: '0.88rem', color: 'var(--ngt-grey)' }}>Also explore: </span>
                    <Link to="/ssc-coaching-ulhasnagar-kalyan">SSC Coaching</Link> ·{' '}
                    <Link to="/science-coaching-ulhasnagar-kalyan">JEE / NEET Coaching</Link> ·{' '}
                    <Link to="/commerce-classes-ulhasnagar-kalyan">Commerce Classes</Link>
                  </div>
                </div>
              </div>

              {/* ── CBSE Toppers ── */}
              {toppers.length > 0 && (
                <div className="ngt-card mt-4">
                  <h3 style={{ fontFamily: 'Playfair Display,serif', color: 'var(--ngt-navy)', marginBottom: '1.2rem' }}>
                    <i className="fas fa-trophy me-2" style={{ color: '#b8860b' }}></i>CBSE Toppers
                  </h3>
                  <div className="topper-scroll">
                    {toppers.map((t, i) => <TopperCard key={t.id || i} topper={t} />)}
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-4">
              <div className="ngt-enquiry-info">
                <h4>Enquire About CBSE Coaching</h4>
                <p style={{ opacity: 0.85, fontSize: '0.92rem', marginBottom: '1.5rem' }}>
                  Ask about CBSE batch timings, fees, and admissions for Class 5 to 10.
                </p>
                <Link to="/enquiry" className="btn-ngt-gold d-block text-center" style={{ marginBottom: '1rem' }}>Submit an Enquiry</Link>
                <a href="tel:+919272136659" className="btn-ngt-outline d-block text-center" style={{ color: '#fff', borderColor: '#fff' }}>
                  <i className="fas fa-phone me-1"></i> Call +91 9272136659
                </a>
                <hr style={{ borderColor: 'rgba(255,255,255,0.15)', margin: '1.5rem 0' }} />
                <div style={{ fontSize: '0.88rem', opacity: 0.8 }}>
                  <p><i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--ngt-gold)' }}></i>Century Branch — Murbad Road, Ulhasnagar</p>
                  <p><i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--ngt-gold)' }}></i>Khemani Branch, Ulhasnagar</p>
                  <p><i className="fas fa-clock me-2" style={{ color: 'var(--ngt-gold)' }}></i>Mon – Sat · 7:00 AM – 8:00 PM</p>
                  <p><i className="fas fa-envelope me-2" style={{ color: 'var(--ngt-gold)' }}></i>ngt.mailer@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoursesCBSE;